module.exports = __webpack_public_path__ + "img/13.95b27df5.png";